<template>
  <div
    class="expandable-content"
    :style="containerStyles"
    @transitionend="onTransitionEnd"
  >
    <div class="content-wrapper" :style="contentWrapperStyles">
      <slot v-if="shouldRenderSlot"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpandableContent',
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      shouldRenderSlot: this.expanded,
    };
  },
  computed: {
    containerStyles() {
      return {
        height: this.expanded ? `${this.height}px` : '0',
        overflow: 'hidden',
      };
    },
    contentWrapperStyles() {
      return {
        transform: this.expanded
          ? 'translateY(0)'
          : `translateY(-${this.height}px)`,
      };
    },
  },
  watch: {
    expanded(newValue) {
      if (newValue) {
        this.shouldRenderSlot = true;
      }
    },
  },
  methods: {
    onTransitionEnd(e) {
      if (!this.expanded && e.propertyName === 'height') {
        this.shouldRenderSlot = false;
      }
    },
  },
};
</script>

<style scoped>
.expandable-content {
  position: relative;
  transition: height 0.3s ease;
}

.content-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease;
}
</style>
